
























import defaultComponent from "@vuetifyx/utils/defaultComponent";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import phoneNumber from '@/utils/phoneNumber';

export default defaultComponent.apply({
  components: {VuePhoneNumberInput},
  model: {
    prop: "model.value",
    event: "change",
  },
  data() {
    return {
      isValidPhoneNumber: false,
      value: "",
      countryCode: "VN",
      errors: this.errorMessages
    };
  },
  methods: {
    async initialize() {
      this.isValidPhoneNumber = false;
      const countryCodeList = phoneNumber.getCountryCodes()
      if (this.model.value !== undefined && this.model.value && this.context().context().state !== "insert") {
        const index = countryCodeList.findIndex((item) =>
            this.model.value
                .includes(item.value)
        );
        if (index > -1) {
          this.countryCode = countryCodeList[index].text.toUpperCase();
          this.value = this.model.value.substring(
              countryCodeList[index].value.length,
              this.model.value.length
          );
        }
      } else {
        this.value = "";
      }
    },
    updateData(value) {
      if (!value.isValid) {
        this.errors = ['Phone number incorrect format'];
        this.emit('validate', false);
      } else {
        this.errors = [];
        this.emit('validate', true);
      }
      let phoneNumber = "";
      if (value && value.formattedNumber) {
        phoneNumber = value.formattedNumber;
      }
      this.$emit("change", phoneNumber);
    },
  },
  extraOptions: {
    forwardStates: {
      xModel: ["model"],
      errorMessages: [],
    },
  },
});
